module.exports = __webpack_public_path__ + "static/media/utensil-knife.6d758194.svg";